import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Box, Button, Card, CardActionArea, CardContent, Chip, Divider, Grid,
  List, ListItem, ListItemText, Paper, Stack, TextField, Typography,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, MenuItem, Alert,
  Tabs,Tab,
  Icon
} from "@mui/material";
import { color, timeOptions } from "constant/constant";
import { TCInput, TCSelect } from "components/TopCourtComponents/Input/TopCourtInput";
import { IconTrash, IconEdit, IconX, IconPencil } from "@tabler/icons";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import moment from "moment";
import { endMatchService, resetWalkOverService, startMatchService, submitSetScore, updateEndMatchService, woMatchService } from "services/matchServices";
import MatchPlayer from "./matchPlayer";
import TCDateTime from "components/TopCourtComponents/Input/TCDateTime";
import { getTournamentCourt, setMatchInfoService } from "services/tournamentServices";

function ScoreWoDialog({ open, row, onClose, onSaved }) {
  const matchObj = row?.match || row;
  const initialSets = (matchObj?.setScores || matchObj?.scores || [])
    .map(s => typeof s === 'string' ? s.split('-').map(Number) : [s.scoreTeamA, s.scoreTeamB])
    .filter(ab => Array.isArray(ab) && ab.length === 2)
    .map(([a,b]) => ({ a: Number(a)||0, b: Number(b)||0 }));

  const [mode, setMode] = useState(row?.walkover || matchObj?.walkover ? "wo" : "normal");
  const [sets, setSets] = useState(initialSets.length ? initialSets : [{ a: 0, b: 0 }]);
  const [saving, setSaving] = useState(false);

  const existingWO = matchObj?.walkover;
  const [woSide, setWoSide] = useState(existingWO?.side || "a");
  const [woReason, setWoReason] = useState(matchObj?.woReason || "");
  const [woNotes, setWoNotes] = useState(existingWO?.notes || "");
  const [woPlayerId, setWoPlayerId] = useState(matchObj?.woPlayerId || "");
  const [tabs, setTabs] = useState(0)
  const [ updateEndTime, setUpdateEndTime ] = useState(null)
  const [ updateStartTime, setUpdateStartTime]  = useState(null)
  const [ matchInfoForm, setMatchInfoForm ] = useState({
      court: null, date: null, hours: null
  })

  const [confirmationDialog, setShowConfirmationDialog] = useState(false)

  useEffect(() => {
    if (open) {
      const init = (matchObj?.setScores || matchObj?.scores || [])
        .map(s => typeof s === 'string' ? s.split('-').map(Number) : [s.scoreTeamA, s.scoreTeamB])
        .filter(ab => Array.isArray(ab) && ab.length === 2)
        .map(([a,b]) => ({ a: Number(a)||0, b: Number(b)||0 }));
      setSets(init.length ? init : [{ a: 0, b: 0 }]);
    }
  }, [open]); // eslint-disable-line

  const addSet = () => setSets(prev => [...prev, { a: 0, b: 0 }]);
  const removeSet = (i) => setSets(prev => prev.filter((_, idx) => idx !== i));
  const updateSet = (i, key, val) => {
    setSets(prev => prev.map((s, idx) => idx === i ? { ...s, [key]: Number(val)||0 } : s));
  };

  const sideA = matchObj?.playersSideA || [];
  const sideB = matchObj?.playersSideB || [];

  const playerOptions = useMemo(() => ([
    ...sideA.map(p => ({ label: `A • ${p.name}`, value: p._id, side: 'a' })),
    ...sideB.map(p => ({ label: `B • ${p.name}`, value: p._id, side: 'b' })),
  ]), [sideA, sideB]);
  
  const sideOptions = useMemo(() => ([
    { label: `${sideA.map((p,i) => `${i > 0 ? ' ' : ''}${p.name}`)}`, value: sideA[0]?.matchGroupPlayerId, side: 'a' },
    { label: `${sideB.map((p,i) => `${i > 0 ? ' ' : ''}${p.name}`)}`, value: sideB[0]?.matchGroupPlayerId, side: 'b' }
  ]), [sideA, sideB])

  useEffect(() => {
    if (matchObj?.woPlayerId) {
        if (sideOptions.some(v => v.value.toString() == matchObj?.woPlayerId.toString())) {
            setWoPlayerId(sideOptions.find(v => v.value.toString() == matchObj?.woPlayerId.toString())?.value)
        }
    }
  }, [sideOptions])

  const saveNormalScore = async () => {
    try {
      setSaving(true);
      // const payloadScores = sets
      //   .filter(s => (s.a > 0 || s.b > 0))
      //   .map(s => `${s.a}-${s.b}`);
      const payloadScores = sets
      if (matchObj?.isTournament) {
          if ((matchInfoForm.court && matchInfoForm.date)
              && (matchInfoForm.court?.value.toString() != matchObj?.courtId?.toString() || matchInfoForm.date != matchObj?.date || matchInfoForm.hours != matchObj?.hour)
          ) {
              matchInfoForm.hours = matchInfoForm.hours ? matchInfoForm.hours.split(':').length > 0 ? matchInfoForm.hours : `${matchInfoForm.hours}:${matchInfoForm.minutes}` : null
              await setMatchInfoService({
                  matchId: matchObj?._id,
                  court: matchInfoForm.court ? matchInfoForm.court.value : null,
                  date: matchInfoForm.date ? matchInfoForm.date : null, 
                  hours: matchInfoForm.hours 
              })
              await onSaved();
              return;
          }
        if (updateStartTime || updateEndTime) {
          await updateEndMatchService({
              matchId: matchObj._id, dateInfo: updateEndTime? toMoment(updateEndTime) : null, dateStartInfo: updateStartTime ? toMoment(updateStartTime) : null
          })
        }
      }
      await submitSetScore({
        matchId: matchObj._id || row._id || row.matchId,
        scores: payloadScores
      });
      await onSaved();
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  const saveWalkover = async () => {
    try {
      setSaving(true);
      if (!woReason) return;
      await woMatchService({
        matchId: matchObj._id || row._id || row.matchId, 
        matchGroupPlayerId: woPlayerId, 
        woReason
      })
      await onSaved();
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  // const updateMatchEnd = async () => {
  //     setLoading(true)
  //     setBtnLoading(true)
  //     // throw 'error'
  //     let { data, error } = await updateEndMatchService({
  //         matchId: match._id, dateInfo: updateEndTime? toMoment(updateEndTime) : null, dateStartInfo: updateStartTime ? toMoment(updateStartTime) : null
  //     })
  //     setBtnLoading(false)
  //     setLoading(false)
  //     loadMatchDetail()
  // }

  const startMatch = async () => {
    await startMatchService({
      matchId: matchObj._id || row._id || row.matchId, 
    })
    await onSaved();
  }

  const endMatch = async () => {
    await endMatchService({
      matchId: matchObj._id || row._id || row.matchId, 
    })
    await onSaved();
  }

  const resetWalkOver = async () => {
    await resetWalkOverService({
      matchId: matchObj._id || row._id || row.matchId, 
    })
    await onSaved();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      sx={{
        '& .MuiDialog-paper': { overflow: 'visible' },
        '& .MuiDialogContent-root': { overflow: 'visible' },
      }}
    >
      {/* <DialogTitle>Update Score / Walkover</DialogTitle> */}
      <Tabs
          // orientation="vertical"
          orientation="horizontal"
          variant="scrollable"
          value={tabs}
          onChange={(e, newValue) => {
              setTabs(newValue)
              setMode(newValue == 0 ? "normal" : "wo")
          }}
          sx={{ borderRight: 1, borderColor: 'divider' }}
      >
          {/* check here */}
          <Tab label="Match Point"/>
          {/* <Tab label="Swap Player"/> */}
          <Tab label="Walkover"/>
          {/* <Tab label="Order"/>
          <Tab label="Match"/>
          <Tab label="Class"/>
          <Tab label="Academy"/>
          <Tab label="OTP"/> */}
      </Tabs>
      <DialogContent dividers>
        {existingWO && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This match currently has a <b>Walkover</b> set: side <b>{existingWO.side?.toUpperCase()}</b>
            {existingWO.playerName && <> • Player <b>{existingWO.playerName}</b></>}
            {existingWO.reason && <> • Reason: <b>{existingWO.reason}</b></>}
          </Alert>
        )}

        {/* <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
          <Button variant={mode==="normal"?"contained":"outlined"} onClick={()=>setMode("normal")}></Button>
          <Button variant={mode==="wo"?"contained":"outlined"} color="warning" onClick={()=>setMode("wo")}></Button>
          {existingWO && <Button color="inherit" onClick={clearWalkover} disabled={saving}>Clear WO</Button>}
        </Stack> */}
        <Grid container>
          {
            matchObj?.isTournament &&
            <SetMatchInformation match={matchObj} finalScore={''} setMatchInfoForm={setMatchInfoForm}/>
          }
        </Grid>

        <MatchPlayer sideA={sideA} sideB={sideB}/>
        <div style={{marginBottom: 8}}/>

        {mode === "normal" ? (
          <Box>
            {/* <Typography variant="subtitle2" sx={{ mb: 1 }}>Per-set Scores</Typography> */}
            {/* get information */}
            <Grid container spacing={1}>
              {sets.map((s, i) => (
                <Grid item container xs={12} spacing={2}>
                  <Grid item xs={4} md={3}>
                    <TCInput type="number" inputProps={{ min: 0 }} value={s.a}
                    onChange={(e)=>updateSet(i,'a',e.target.value)}/>
                  </Grid>
                  <Grid item xs={4} md={3}>
                    <TCInput type="number" inputProps={{ min: 0 }} value={s.b}
                    onChange={(e)=>updateSet(i,'b',e.target.value)}/>
                  </Grid>
                  <Grid item>
                    {
                      (i == sets.length - 1) ?
                      <Button variant="contained" size="small" onClick={addSet}>Add set</Button>
                      :
                      <Button size="small" color="error" onClick={()=>removeSet(i)} disabled={sets.length<=1}>
                        <IconTrash/>
                      </Button>
                    }
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid mt={1.5}>
              {/* <Grid>
                <TCLabel subtitle>Start: {matchObj?.startMatch ? moment(matchObj?.startMatch).format('YYYY-MM-DD HH:mm') : '-'}</TCLabel>
              </Grid> */}
              <Grid mt={0.5}>
                {/* <TCLabel subtitle>End: {moment(matchObj?.endMatch).format('YYYY-MM-DD HH:mm')}</TCLabel> */}
                {/* <UpdateEndTime match={matchObj} onUpdateEndTime={(e) => {
                  setEndTime(e)
                }}/> */}
                {
                    (matchObj?.status == "live" || matchObj?.status == "end") &&
                    <UpdateEndTime match={matchObj} matchBE={matchObj} onUpdateEndTime={(e) => {
                        console.log('here e end', e)
                        setUpdateEndTime(e)
                    }} onUpdateStartTime={(e) => {
                        console.log('here e start', e)
                        setUpdateStartTime(e)
                    }} />
                }
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box>
            {/* <Typography variant="subtitle2" sx={{ mb: 1 }}>Walkover Details</Typography> */}
            {/* Show Side A and Side B*/}
            <Stack spacing={1} mt={2}>
              <TCLabel>WO Participant</TCLabel>
              <TextField disabled={matchObj?.woPlayerId} style={{
                marginTop: 2, background: 'white'
              }} select size="small" value={woPlayerId} onChange={(e)=>setWoPlayerId(e.target.value)}>
                {
                  sideOptions.map(v => {
                    return (
                      <MenuItem value={v.value}>{v.label}</MenuItem>
                    )
                  })
                }
              </TextField>
              {/* <TCSelect
                inDialog
                label={"WO Side"}
                onChange={(e)=>setWoSide(e.target.value)}
                // options={}
              /> */}
              <TextField size="small" placeholder="Reason" value={(matchObj?.isWO && matchObj?.woReason) ? matchObj?.woReason : woReason} onChange={(e)=>setWoReason(e.target.value)} multiline minRows={2}/>
              {/* <Alert severity="info">Winner will be awarded to the opposite side of the forfeiting team/player.</Alert> */}
              {/* {matchObj?.isWO ? <div>Reset WO</div> : <div></div>} */}
            </Stack>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Grid container xs={12} p={2} pt={0} pb={2}>
          <Grid item xs={6}>
            {
              (matchObj?.startMatch) &&
              <Button onClick={endMatch} variant="contained" disabled={saving || matchObj?.endMatch}>{'End Match'}</Button>
            }
            {
              (!matchObj?.startMatch) &&
              <Button onClick={startMatch} variant="contained" disabled={saving || matchObj?.isWO}>{'Start Match'}</Button>
            }
          </Grid>
          <Grid item xs={6} textAlign={"right"}>
            <Button onClick={onClose} disabled={saving}>Cancel</Button>
            {mode === "normal"
              ? <Button onClick={saveNormalScore} variant="contained" disabled={saving}>Update</Button>
              : matchObj?.isWO ? <Button onClick={resetWalkOver} variant="contained" disabled={saving}>Reset Walkover</Button> : <Button onClick={saveWalkover} variant="contained" disabled={saving || !woReason}>Apply Walkover</Button>}
          </Grid>
        </Grid>
      </DialogActions>
      {/* {
        confirmationDialog &&
        <Dialog open={confirmationDialog}>
        </Dialog>
      } */}
    </Dialog>
  );
}

function SetMatchInformation ({
    match, finalScore, setMatchInfoForm
}) {

    const [ showSetCourt, setShowSetCourt ] = useState(true)
    const [ form, setForm ] = useState({
        court: match?.courtId, date: match?.date, hours: match?.hour
    })
    const [ courtOptions, setCourtOptions ] = useState([])
    const [ dateOptions, setDateOptions ] = useState([])
    const [ calendarConfig, setCalendarConfig ] = useState({
        minAllowed: new Date(),
        maxAllowed: moment(new Date()).add(30, 'day')
    })

    useEffect(() => {
        loadCourtTournament()
    }, [])

    useEffect(() => {
        if (courtOptions.length > 0 && match) { 
            setForm({
                court: courtOptions.find(v => v.value.toString() == match?.courtId?.toString()), 
                date: match?.date, 
                hours: match?.hour?.split(':')[0],
                minutes: match?.hour?.split(':')[1]
            })
        }
    }, [match, courtOptions])

    useEffect(() => {
        setShowSetCourt(true)
    }, [ match ])

    useEffect(() => {
        if (form.edited) { setMatchInfoForm(form) }
    }, [form])

    useEffect(() => {
        console.log('here court options', courtOptions)
    }, [courtOptions])

    const loadCourtTournament = async () => {
        let { data, error } = await getTournamentCourt({
            tournamentId: match._id
        })
        console.log('here data info', data)
        if (data) {
            let courts = data.courts.map(v => {
                return {
                    label: `${v.sportCourtTypeId.name} ${v.name}`,
                    value: v._id
                }
            })
            // let dates = expandDateRange(data.dates)
            let dates = data.dates
            let sortedDates = dates.sort(
                (a, b) => moment(a.value, "YYYY-MM-DD").valueOf() - moment(b.value, "YYYY-MM-DD").valueOf()
            ).map(v => {
                return {
                    label: v,
                    value: v
                }
            })
            
            console.log('here data info', courts)
            setCourtOptions([...courts])
            setDateOptions(sortedDates)
            setCalendarConfig({
                minAllowed: moment(sortedDates[0].value).format("YYYY-MM-DD"),
                maxAllowed: moment(sortedDates[sortedDates.length - 1].value).format("YYYY-MM-DD")
            })
        } else { setCourtOptions([]); setCourtOptions([]) }
    }

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
    }

    return (
        <>
            {
                showSetCourt &&
                <>
                    <Grid container spacing={0.5} xs={12} alignItems={"center"} mb={.5}>
                        <Grid item xs={4}>
                            <TCSelect placeHolder={"Court"} value={form.court} options={courtOptions} 
                                isSearchable={false}
                                // inDialog={true}
                                styles={{
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                    // overall height
                                    control: (base) => ({ ...base, 
                                        fontSize: '13px',
                                        border: '0.5px',
                                        backgroundColor: '#f8fafc',
                                        borderRadius: 2,
                                        minHeight: 28 
                                    }),

                                    // make the indicator area smaller (both chevron + clear X)
                                    dropdownIndicator: (base) => ({ ...base, padding: 2 }),   // was ~8
                                    clearIndicator:    (base) => ({ ...base, padding: 2 }),
                                    indicatorsContainer: (base) => ({ ...base, paddingRight: 0 }),

                                    // thinner/shorter separator (or hide with display:'none')
                                    indicatorSeparator: (base) => ({
                                        ...base,
                                        width: 1,
                                        marginTop: 6,
                                        marginBottom: 6,
                                        opacity: 0.6,
                                    }),
                                    }}
                                // inDialog={true}
                                onChange={(e) => {
                                    onChange({court: e, edited: true})
                                }}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            {/* <TCSelect placeHolder={"Date"} 
                                styles={{
                                    menu: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                // inDialog={true}
                                value={form.date} options={dateOptions}
                                onChange={(e) => {
                                    onChange({date: e})
                                }}
                            /> */}
                            {/* <TCInput
                                type="datetime-local"
                                value={form.date}
                                onChange={(e) => { onChange({date: e}) }}
                                inputProps={{ 
                                    InputProps: {
                                        inputProps: {
                                            min: moment(new Date()).add(-1, 'day').format("YYYY-MM-DDT00:00:00"), max: moment(new Date()).format("YYYY-MM-DDT23:59:59")
                                        }
                                    }
                                }}
                            /> */}
                            <TCDateTime label="" minuteStep={1}
                                value={form}
                                dateOptions={dateOptions}
                                minDate={calendarConfig.minAllowed}
                                maxDate={calendarConfig.maxAllowed}
                                onChange={(e) => {
                                    console.log('here e', e)
                                    onChange({
                                        date: e.date?.label,
                                        hours: `${e.hours?.label}:${e.minutes?.label || '00'}`,
                                        edited: true
                                    })
                                }}
                            />
                        </Grid>
                        {/* <Grid item xs={3.5}>
                            <TCSelect placeHolder={"Time"} 
                                styles={{
                                    menu: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                // inDialog={true}
                                value={form.hours} options={hoursOptions}
                                onChange={(e) => {
                                    onChange({hours: e})
                                }}
                            />
                        </Grid> */}
                        {/* <Grid item xs={.5} onClick={() => {
                            setShowSetCourt(false)
                        }}><TCLabel>X</TCLabel></Grid> */}
                    </Grid>
                </>
            }
            {
                !showSetCourt &&
                <>
                    <Grid item xs={8.5} px={1} onClick={() => {
                        if (!match.endMatch) { setShowSetCourt(true) }
                    }}><TCLabel bold>{`${match.name}` || `Round 1`}</TCLabel></Grid>
                    <Grid xs={3.5} textAlign={"right"} onClick={() => {
                        if (!match.endMatch) { setShowSetCourt(true) }
                    }}><TCLabel bold style={{ fontSize: 15 }}>{match.isWO ? match.finalScore : finalScore}</TCLabel></Grid>
                </>
            }
            <Grid item xs={12}>
                <Divider sx={{ marginY: 0.6, marginTop: 0.2, background: color.blueIndoor_1}}/>
            </Grid>
        </>
    )
}

function UpdateEndTime({ match, matchBE, onUpdateEndTime, onUpdateStartTime }) {
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);
    const [ dateOptions, setDateOptions ] = useState([]);

    const startMatch = match?.startMatch || matchBE?.startMatch
    const endMatch = match?.endMatch || matchBE?.endMatch

    const initialLocal = useMemo(() => {
        if (!match?.endMatch) return "";
        return moment(match.endMatch).format("YYYY-MM-DDTHH:mm");
    }, [match?.endMatch]);

    useEffect(() => {
        loadCourtTournament()
    }, [])

    const addHoursPad = (input, offset = 7) => {
        // helper to read number from string/number/{label}
        const toNum = (v) => {
            if (v == null) return NaN;
            if (typeof v === "object" && "label" in v) return parseInt(v.label, 10);
            return parseInt(v, 10);
        };

        // Case A: ISO UTC date string in input.date
        if (typeof input?.date === "string" && /T.+Z$/.test(input.date)) {
            const m = moment.utc(input.date).add(offset, "hours");
            return {
            date: m.format("YYYY-MM-DD"),
            hours: m.format("HH"),
            minutes: m.format("mm"),
            };
        }

        // Case B: separate parts (assume input.date is 'YYYY-MM-DD')
        const dateStr = input?.date;
        if (!moment(dateStr, "YYYY-MM-DD", true).isValid()) {
            throw new Error(`Invalid date: ${dateStr}`);
        }

        const h = toNum(input?.hours);
        if (!Number.isFinite(h)) throw new Error(`Invalid hours: ${input?.hours}`);

        const mm = toNum(input?.minutes);
        const mSafe = Number.isFinite(mm) ? mm : 0;

        const baseUtc = moment.utc(
            `${dateStr}T${String(h).padStart(2, "0")}:${String(mSafe).padStart(2, "0")}:00Z`
        );

        const shifted = baseUtc.add(offset, "hours");

        return {
            date: shifted.format("YYYY-MM-DD"),
            hours: shifted.format("HH"),
            minutes: shifted.format("mm"),
        };
    };

    const loadCourtTournament = async () => {
        let { data, error } = await getTournamentCourt({
            tournamentId: match._id
        })
        console.log('here data info', data)
        if (data) {
            let courts = data.courts.map(v => {
                return {
                    label: `${v.sportCourtTypeId.name} ${v.name}`,
                    value: v._id
                }
            })
            // let dates = expandDateRange(data.dates)
            let dates = data.dates
            let sortedDates = dates.sort(
                (a, b) => moment(a.value, "YYYY-MM-DD").valueOf() - moment(b.value, "YYYY-MM-DD").valueOf()
            ).map(v => {
                return {
                    label: v,
                    value: v
                }
            })
            
            console.log('here data info', courts)
            // setCourtOptions([...courts])
            setDateOptions(sortedDates)
            // setCalendarConfig({
            //     minAllowed: moment(sortedDates[0].value).format("YYYY-MM-DD"),
            //     maxAllowed: moment(sortedDates[sortedDates.length - 1].value).format("YYYY-MM-DD")
            // })
        }
    }

    const addOneDays = ({ dates = [] }) => {
        if (!Array.isArray(dates) || dates.length === 0) return dates;

        // find the max date (ISO strings compare correctly)
        const last = dates.reduce((max, cur) =>
            cur.value > max.value ? cur : max
        );

        const next = moment(last.value, "YYYY-MM-DD", true).add(1, "day");
        if (!next.isValid()) return dates;

        const nextStr = next.format("YYYY-MM-DD");
        return [...dates, { label: nextStr, value: nextStr }];
    };

    const initialLocalStart = useMemo(() => {
        console.log('here intial local', startMatch)
        if (!startMatch) return "";
        let date = startMatch.split('T')[0]
        let hours = startMatch.split('T')[1].split(':')[0]
        let minutes = startMatch.split('T')[1].split(':')[1]
        let newObj = addHoursPad({
            date: date,
            hours: hours,
            minutes: minutes,
        })
        return {
            ...newObj,
            dateFormat: toMoment(newObj)
        };
    }, [startMatch]);

    const initialLocalEnd = useMemo(() => {
        console.log('here intial local', endMatch)
        if (!endMatch) return "";
        let date = endMatch.split('T')[0]
        let hours = endMatch.split('T')[1].split(':')[0]
        let minutes = endMatch.split('T')[1].split(':')[1]
        let newObj = addHoursPad({
            date: date,
            hours: hours,
            minutes: minutes,
        })
        return {
            ...newObj,
            dateFormat: toMoment(newObj)
        };
    }, [endMatch]);

    const [ value, setValue] = useState(initialLocal);
    const [ startValue, setStartValue ] = useState(initialLocalStart);
    const [ endValue, setEndValue] = useState(initialLocalEnd);

    useEffect(() => {
        setValue(initialLocal);
    }, [initialLocal, initialLocalStart, initialLocalEnd]);

    // useEffect(() => {
    //     if (endValue != initialLocalEnd) { onUpdateEndTime(endValue) }
    // }, [endValue])

    // useEffect(() => {
    //     if (startValue != initialLocalStart) { onUpdateStartTime(startValue) }
    // }, [startValue])

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div>
                {
                    (match.status && match.status != "not set") &&
                    <div>
                        <TCLabel subtitle>{(match.status == "live" || match.status == "end" || matchBE?.status == "live" || matchBE?.status == "end") ? 
                        `Start ${(match.startMatch || matchBE?.startMatch) ? moment(startValue?.dateFormat ? startValue.dateFormat : match.startMatch || matchBE?.startMatch).format('YYYY-MM-DD HH:mm') : '-'}` : 
                        match.status == "not before" ? `Not before ${match.date} ${match.hour}` : ''}</TCLabel>
                    </div>
                }
                {
                    (match.status == "end" || matchBE?.status == "end") &&
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <TCLabel subtitle style={{
                            marginTop: 0
                        }}>
                            {match?.endMatch ? `End ${moment(endValue?.dateFormat ? endValue.dateFormat : match.endMatch).format("YYYY-MM-DD HH:mm")}` : "End —"}
                        </TCLabel>
                    </div>
                }
            </div>
            {
                ((match.startMatch || match.endMatch || matchBE.startMatch || matchBE.endMatch)) &&
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 24,
                    width: 24,
                    paddingLeft: 8,
                    borderRadius: 10,
                    color: color.blueIndoor_1,
                }} onClick={() => {
                    setEditing(true)
                }}>
                    <IconPencil sx={{ fontSize: 24, verticalAlign: "middle" }}/>
                </div>
            }
            {
                editing && 
                <Dialog 
                  open={editing}
                  onClose={() => setEditing(false)}
                  sx={{
                    '& .MuiDialog-paper': { overflow: 'visible' },
                    '& .MuiDialogContent-root': { overflow: 'visible' },
                  }}
                >
                    <Grid container spacing={1} p={2}>
                            <Grid item xs={12}>
                                <TCDateTime minuteStep={1} label="Start" 
                                    dateOptions={dateOptions}
                                    disabled={!initialLocalStart}
                                    // minDate={calendarConfig.minAllowed}
                                    // maxDate={calendarConfig.maxAllowed}
                                    value={startValue || initialLocalStart} onChange={(e) => {
                                    console.log('here e', e)
                                    if (!e.date || !e.hours || !e.minutes) { return; }
                                    setStartValue({
                                        ...e,
                                        date: e.date?.label,
                                        hours: e.hours?.label,
                                        minutes: e.minutes?.label,
                                        dateFormat: toMoment({
                                            ...e,
                                            date: e.date?.label,
                                            hours: e.hours?.label,
                                            minutes: e.minutes?.label,
                                        })
                                    })
                                    if (initialLocalEnd) {
                                        let newDates = addOneDays({dates: [e.date]})[0]?.label
                                        setEndValue({
                                            ...e,
                                            date: newDates,
                                            hours: e.hours?.label,
                                            minutes: e.minutes?.label,
                                            date: newDates,
                                                dateFormat: toMoment({
                                                ...e,
                                                date: newDates,
                                                hours: e.hours?.label,
                                                minutes: e.minutes?.label,
                                            })
                                        })
                                    }
                                }}/>
                            </Grid>
                            <Grid item xs={12}>
                                <TCDateTime minuteStep={1} label="End" value={endValue || initialLocalEnd} 
                                    dateOptions={addOneDays({dates: [{label: startValue?.date, value: startValue?.date}]})}
                                    disabled={!initialLocalEnd}
                                    // minDate={calendarConfig.minAllowed}
                                    // maxDate={calendarConfig.maxAllowed}
                                    disabledHours={[startValue?.hours]}
                                    disabledMinutes={startValue?.hours == endValue?.hours ? [startValue?.minutes] : []}
                                    onChange={(e) => {
                                        console.log('here e', e)
                                        if (!e.date || !e.hours || !e.minutes) { return; }
                                        setEndValue({
                                            ...e,
                                            date: e.date?.label,
                                            hours: e.hours?.label,
                                            minutes: e.minutes?.label,
                                            dateFormat: toMoment({
                                                ...e,
                                                date: e.date?.label,
                                                hours: e.hours?.label,
                                                minutes: e.minutes?.label,
                                            })
                                    })
                                }}/>
                            </Grid>
                            <Grid item xs={12} style={{
                                textAlign: 'right'
                            }}>
                                <Button 
                                    variant="contained" size="small"
                                    onClick={(e) => {
                                        if (startValue != initialLocalStart) { onUpdateStartTime(startValue) }
                                        if (endValue != initialLocalEnd) { onUpdateEndTime(endValue) }
                                        setEditing(false)
                                    }}
                                >
                                    <span style={{marginTop: 2}}>{"Done"}</span>
                                </Button>
                            </Grid>
                    </Grid>
                </Dialog>
            }
        </div>
    );
}

function toMoment({ date, hours, minutes }, { addHours = 0, toUTC = false, tz } = {}) {
    let m = moment(`${date} ${hours}:${minutes}`, 'YYYY-MM-DD HH:mm', true);
    if (!m.isValid()) throw new Error('Invalid date/hours/minutes');

    if (tz) m = m.tz(tz);          // e.g. tz: 'Asia/Jakarta' (requires moment-timezone)
    if (addHours) m = m.add(addHours, 'hours');
    if (toUTC) m = m.utc();

    return m; // Moment instance
}

export default ScoreWoDialog